import React, { createContext, useState, useCallback, useRef } from 'react';

export const DebugContext = createContext();

export const DebugProvider = ({ children }) => {
  const [isDebugMode, setIsDebugMode] = useState(false);
  const [debugLogs, setDebugLogs] = useState([]);
  const logIdCounter = useRef(0);
  const isDebugModeRef = useRef(isDebugMode);

  // isDebugMode değiştiğinde ref'i güncelle
  React.useEffect(() => {
    isDebugModeRef.current = isDebugMode;
  }, [isDebugMode]);

  // Global window objesine debug context'i ekle (fetchWrapper'dan erişilebilmesi için)
  // Her zaman mevcut olmalı ve her zaman log eklemeli (isDebugMode sadece UI gösterimi için)
  React.useEffect(() => {
    window.debugContext = {
      addDebugLog: (logData) => {
        // Her zaman log ekle, isDebugMode sadece UI'da gösterim için kullanılacak
        const logId = ++logIdCounter.current;
        const timestamp = Date.now();
        const log = {
          id: logId,
          timestamp,
          formattedTime: new Date(timestamp).toLocaleTimeString('tr-TR', { 
            hour: '2-digit', 
            minute: '2-digit', 
            second: '2-digit',
            fractionalSecondDigits: 3
          }),
          ...logData
        };
        setDebugLogs(prev => [log, ...prev.slice(0, 999)]);
        
        // debug_diagrun bilgisini console'da göster
        if (logData.debugDiagrun || logData.debug_diagrun) {
          const debugDiagrun = logData.debugDiagrun || logData.debug_diagrun;
        }
      }
    };
    
    return () => {
      delete window.debugContext;
    };
  }, []); // Sadece mount/unmount'ta çalış

  // Debug log ekleme fonksiyonu
  const addDebugLog = useCallback((logData) => {
    if (!isDebugMode) return; // Debug mode kapalıysa log ekleme
    
    const logId = ++logIdCounter.current;
    const timestamp = Date.now();
    
    const log = {
      id: logId,
      timestamp,
      formattedTime: new Date(timestamp).toLocaleTimeString('tr-TR', { 
        hour: '2-digit', 
        minute: '2-digit', 
        second: '2-digit',
        fractionalSecondDigits: 3
      }),
      ...logData
    };
    
    setDebugLogs(prev => [log, ...prev.slice(0, 999)]); // Son 1000 log'u tut
  }, [isDebugMode]);

  // Debug logları temizleme
  const clearDebugLogs = useCallback(() => {
    setDebugLogs([]);
    logIdCounter.current = 0;
  }, []);

  // Debug mode toggle
  const toggleDebugMode = useCallback(() => {
    setIsDebugMode(prev => {
      const newValue = !prev;
      // Ref'i de güncelle
      isDebugModeRef.current = newValue;
      
      // Debug mode açılırken logları temizleme - artık loglar her zaman kaydediliyor
      // Sadece UI gösterimi için toggle yapıyoruz
      return newValue;
    });
  }, []);

  const contextValue = {
    isDebugMode,
    toggleDebugMode,
    debugLogs,
    addDebugLog,
    clearDebugLogs
  };

  return (
    <DebugContext.Provider value={contextValue}>
      {children}
    </DebugContext.Provider>
  );
};

